














import { Component, Prop, Vue } from 'vue-property-decorator';
let topicType = 0;

@Component
export default class Browse extends Vue {
    @Prop()
    private libraryId !: number;
    @Prop()
    private chapterId !: number;

    private loading = false;

    private topics = [];

    created() {
        this.reload();
    }

    reload() {
        this.$apis.getTopics(this.libraryId, this.chapterId)
            .then((res: any) => {
                this.topics = res.data;
            });
    }

    get title() {
        return (item: any) => {
            if (topicType != item.topicType) {
                topicType = item.topicType;
                return topicType == 1 ? "<p>一、单选题</p>" : topicType == 2 ? "<p>二、多选题</p>" : "<p>三、判断题</p>";
            }
            return "";
        }
    }
}
